const fallbackCopyTextToClipboard = (text: string): void => {
    if (typeof document === 'undefined' || !document.body) {
        throw new Error('Document unavailable')
    }

    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', 'true')
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    textarea.style.left = '-9999px'

    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    try {
        const copied = typeof document.execCommand === 'function'
            ? document.execCommand('copy')
            : false

        if (!copied) {
            throw new Error('execCommand copy failed')
        }
    } finally {
        document.body.removeChild(textarea)
    }
}

export const copyTextToClipboard = async (text: string): Promise<void> => {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text)
            return
        } catch (error) {
            console.warn('navigator.clipboard.writeText failed, falling back', error)
        }
    }

    fallbackCopyTextToClipboard(text)
}

